import React from "react";
import NumberFormat from "react-number-format";

export default function InputCurrencyBase(props) {
  return (
    <NumberFormat
      thousandSeparator=" "
      decimalSeparator="."
      decimalScale={2}
      fixedDecimalScale={true}
      {...props}
      suffix=""
      prefix="R"
      ref={props?.inputRef}
    />
  );
}
